import React from 'react';
import Icon from 'components/Icon';
import styles from './styles.css';
import cx from 'classnames';

export default ({
  children,
  bottom = 0,
  icon = 'circle-info',
  className = '',
}) => (
  <div className={cx(styles.note, className)} style={{ marginBottom: bottom }}>
    <div className={styles.icon}>
      <Icon name={icon} />
    </div>
    <p>{children}</p>
  </div>
);
